import React from 'react'
import HomeBanner from './HomeBanner'
// import HomeFeature from './HomeFeature'
import HomeChoose from './HomeChoose'
import HomeService from './HomeService'
import HomeProducts from './HomeProducts'
import HomeSustainable from './HomeSustainable'
import HomeIndustries from './HomeIndustries'
import HomeTrusted from './HomeTrusted'
import HomeProjectHighlights from './HomeProjectHighlights'
import HomeTestimonial from './HomeTestimonial'
import HomePartners from './HomePartners'
import HomeCounter from './HomeCounter'
import HomeMap from './HomeMap'

export default function Home({ initialData }) {

  const industriesData = {
    title: "Our Core Services",
    items: [
      { title: "Assessment & Project <br> planning", desc: "We do a professional survey and planning to optimize productivity and resource usage (like water, labor, electricity).", img: "/assets/images/logistics-service1.webp", link1: "/project-planing", btn1: "Learn More", link2: "/contact", btn2: "Know more", },
      { title: "Delivering Worldwide ", desc: "Reliable global supply chain solutions delivering our industrial laundry equipment worldwide with unmatched speed and efficiency.", img: "/assets/images/logistics-service2.webp", link1: "/delivery", btn1: "Learn More", link2: "/contact", btn2: "Know more", },
      { title: "Robust Installation & commissioning ", desc: "Robust installation and commissioning services ensuring seamless setup of our industrial laundry equipment worldwide.", img: "/assets/images/logistics-service3.webp", link1: "/installation", btn1: "Learn More", link2: "/contact", btn2: "Know more", },
      { title: "Expert Operational <br> Training", desc: "We train your team to use the equipment safely and effectively, helping you achieve consistent performance and maximum productivity.", img: "/assets/images/experct-image2.webp", link1: "/training", btn1: "Learn More", link2: "/contact", btn2: "Know more", },
      { title: "Reliable After-sales <br> service", desc: "Our nationwide service network provides timely maintenance and responsive assistance to keep your systems running at peak reliability.", img: "/assets/images/reliable-service-img1.webp", link1: "/sales-service", btn1: "Learn More", link2: "/contact", btn2: "Know more", },
      { title: "Smooth Laundry Operations", desc: "End-to-end management of commercial laundry workflows ensuring efficiency, uptime, compliance, and consistent output quality.", img: "/assets/images/laundry-service-img1.webp", link1: "/project-planing", btn1: "Learn More", link2: "/contact", btn2: "Know more", },
    ],
  };


  const productData = {
    subtitle: "",
    title: "Tailored Products for Every Need",
    // products: [
    //   {
    //     id: 1,
    //     title: "Wet Work Technology",
    //     description:
    //       "High-efficiency washer extractors built for faster cycles and superior cleaning.",
    //     image: "/assets/images/home-product-img1.webp",
    //     buttonText: "Explore Washer Extractors",
    //     brands: [
    //       "/assets/images/product-brand-img1.webp",
    //       "/assets/images/product-brand-img2.webp",
    //       "/assets/images/product-brand-img3.webp",
    //     ],
    //   },
    //   {
    //     id: 2,
    //     title: "Dry Work Technology",
    //     description: "High-performance drying tumblers for faster, safe fabric dry cleaning.",
    //     image: "/assets/images/home-product-img2.webp",
    //     buttonText: "Explore Drying Tumblers",
    //     brands: [
    //       "/assets/images/product-brand-img4.webp",
    //       "/assets/images/product-brand-img5.webp",
    //       "/assets/images/product-brand-img6.webp",

    //     ],
    //   },
    //   {
    //     id: 3,
    //     title: "Flat Work Technology",
    //     description: "Efficient feeding, ironing and folding solutions.",
    //     image: "/assets/images/home-product-img3.webp",
    //     buttonText: "Explore Flatwork Ironers",
    //     brands: [
    //       "/assets/images/product-brand-img8.webp",
    //       "/assets/images/product-brand-img2.webp",

    //       "/assets/images/product-brand-img6.webp",
    //       // "/assets/images/flat-image1.webp",

    //     ],
    //   },

    //   {
    //     id: 4,
    //     title: "Finishing Technology",
    //     description: "Professional solutions for consistent, high quality finishing.",
    //     image: "/assets/images/finishing-image.webp",
    //     buttonText: "Explore Presses",
    //     brands: [
    //       "/assets/images/finishing-brand-logo3.webp",
    //       "/assets/images/finishing-brand-logo2.webp",
    //       "/assets/images/finishing-brand-logo1.webp",



    //     ],
    //   },

    //   {
    //     id: 5,
    //     title: "Drycleaning Technology",
    //     description: "Advanced systems for precise, safe fabric cleaning.",
    //     image: "/assets/images/dryness-img.webp",
    //     buttonText: "Explore Dry Cleaning Machines",
    //     brands: [
    //       "/assets/images/dry-clean-img1.webp",
    //       "/assets/images/dry-clean-img2.webp",
    //     ],
    //   },

    //   {
    //     id: 6,
    //     title: "Other Technology",
    //     description:
    //       "Support equipment for efficient, reliable operations.",
    //     image: "/assets/images/other-system-img.webp",
    //     buttonText: "Explore Other Technologies",
    //     brands: [
    //       "/assets/images/other-brand-image1.webp",
    //       "/assets/images/other-brand-image2.webp",
    //       "/assets/images/other-brand-image3.webp",
    //       "/assets/images/lg-new-img.webp",
    //       "/assets/images/new-other-brand-image5.webp",
    //       "/assets/images/new-other-brand-image6.webp",
    //       "/assets/images/new-other-brand-image7.webp",
    //       "/assets/images/new-other-brand-image8.webp",
    //     ],
    //   },
    // ],
  };



  const testimonialdata = [
    {
      text: "What stood out was consistency. From installation to daily performance, Supershine delivers exactly what was committed, without surprises. Their team remains accessible long after commissioning is complete. That continuity builds real operational confidence.",
      image: "/assets/images/faisal-author-img.webp",
      name: "Faisal Al-Rashid",
      designation: "General Manager"
    },
    {
      text: "Supershine’s solutions have helped us standardise quality across locations while keeping operations efficient and predictable. Processes are easier to monitor and outcomes remain uniform across sites. This has simplified scale without compromising control.",
       image: "/assets/images/neha-sharma-testimonial.webp",
      name: "Neha Khanna",
      designation: "Regional Head"
    },


    {
      text: "With Supershine, performance remains stable even under high-volume demand. Their understanding of scale and service reliability makes a real difference. Support response times are clear and dependable. That assurance is critical in large, continuous operations.",
      image: "/assets/images/chinedu-author-img.webp",
      name: "Chinedu Okafor",
      designation: "Head of Operations "
    },
       {
      text: "Supershine understands the realities of Industrial laundry operations. Their systems are dependable, their support is responsive, and downtime is never an issue. Even during peak hospital demand, performance remains stable and predictable.",
      image: "/assets/images/ecclips-author-img.webp",
      name: "Anil Mehra",
      designation: "Facility Operations Head"
    },
   
  ];



  return (
    <>
      <div className="home-page">
        <HomeBanner />
        {/* <HomeFeature /> */}
        <HomeChoose />
        <HomeService data={industriesData} />
        <HomeMap />
        <HomeCounter />
        <HomeProducts data={productData} initialData={initialData} />
        <HomeSustainable />
        <HomeIndustries />
        <HomeTrusted />
        <HomeProjectHighlights />
        <HomeTestimonial data={testimonialdata} />
        <HomePartners />
      </div>
    </>
  )
}
